export const LIVE_GAMES_IS_NEED_TO_START_UPDATE = 'LIVE_GAMES:IS_NEED_TO_START:UPDATE';

export const startLiveIntegration = () => ({
    type: LIVE_GAMES_IS_NEED_TO_START_UPDATE,
    payload: true
});
